import {useEffect, useState} from "react";
import {Affix, Button, Card, Col, message, Row, Spin, Steps, Tooltip} from "antd";
import LogoImage from "../../../assets/img/logo1.png";

import './style.scss';
import UserDetails from "../../components/individualAccSteps/userDetail";
import ContactDetails from "../../components/individualAccSteps/contactDetail";
import OccupationDetails from "../../components/individualAccSteps/occupationDetail";
import BankAccountDetails from "../../components/individualAccSteps/bankAccountDetail";
import OtherDetail from "../../components/individualAccSteps/otherDetail";
import AttachmentAndSupportingDetail from "../../components/individualAccSteps/attachmentAndSupportingDetail";
import Acknowledgement from "../../components/individualAccSteps/acknowledgment";
import {CustomerWrapperDto} from "../../dto/CustomerWrapperDto";
import customerService from "../../service/customerService";
import keycloak, {getUserInfo} from "../../security/KeyclockConfig";
import SummaryDetail from "../../components/individualAccSteps/summaryDetail";
import {RouteComponentProps, useHistory} from "react-router-dom";
import ErrorHandler from "../../util/ErrorHandler";
import {MSG_UNABLE_TO_SAVE_CUSTOMER_DETAILS_ERROR} from "../../util/Messages";
import {PoweroffOutlined} from '@ant-design/icons/lib';
import {
    step_1_active_img,
    step_1_inactive_img,
    step_2_active_img,
    step_2_inactive_img,
    step_3_active_img,
    step_3_inactive_img,
    step_4_active_img,
    step_4_inactive_img,
    step_5_active_img,
    step_5_inactive_img,
    step_6_active_img,
    step_6_inactive_img,
    step_7_active_img,
    step_7_inactive_img,
    step_8_active_img,
    step_8_inactive_img, xappHomeLogo
} from '../../../AppImageConst';
import {ACCOUNT_TYPE} from "../../util/Constants";
import SecondApplicantDetail from "../../components/jointAccSteps/secondApplicantDetail";


const StepperContainerIndividualAccount = (props: RouteComponentProps) => {
    const redirectUri: string | undefined = process.env.REDIRECT_URI ? process.env.REDIRECT_URI : "http://localhost:3000/";
    const [savedUserDetail, setSavedUserDetail] = useState<CustomerWrapperDto>();
    const [isSpinnerLoading, setSpinnerLoad] = useState(false);
    const [current, setCurrent] = useState(1);
    const [accType, setAccType] = useState<number | undefined>(ACCOUNT_TYPE.INDIVIDUAL_ACCOUNT);
    const [refNumber, setRefNumber] = useState("");

    const history = useHistory();

    const getIconClassName = (stepValue: number) => {
        return stepValue < (savedUserDetail?.currentActiveStep == undefined ? 0 : savedUserDetail.currentActiveStep) ? 'stepper-icon-container' : ''
    };
    let stepsActive = [
        {
            icon: <img className={getIconClassName(1)} src={step_1_active_img}/>
        },
        {
            icon: <img className={getIconClassName(2)} src={step_2_active_img}/>
        },
        {
            icon: <img className={getIconClassName(3)} src={step_3_active_img}/>
        },
        {
            icon: <img className={getIconClassName(4)} src={step_4_active_img}/>
        },
        {
            icon: <img className={getIconClassName(5)} src={step_5_active_img}/>
        },
        {
            icon: <img className={getIconClassName(6)} src={step_6_active_img}/>
        },
        {
            icon: <img className={getIconClassName(7)} src={step_7_active_img}/>
        }

    ];
    let stepsInactive = [
        {
            icon: <img className={getIconClassName(1)} src={step_1_inactive_img}/>
        },
        {
            icon: <img className={getIconClassName(2)} src={step_2_inactive_img}/>
        },
        {
            icon: <img className={getIconClassName(3)} src={step_3_inactive_img}/>
        },
        {
            icon: <img className={getIconClassName(4)} src={step_4_inactive_img}/>
        },
        {
            icon: <img className={getIconClassName(5)} src={step_5_inactive_img}/>
        },
        {
            icon: <img className={getIconClassName(6)} src={step_6_inactive_img}/>
        },
        {
            icon: <img className={getIconClassName(7)} src={step_7_inactive_img}/>
        }
    ];
    const [updatedStepsActive, setUpdatedStepsActive] = useState(stepsActive);
    const [updatedStepsInactive, setUpdatedStepsInactive] = useState(stepsInactive);

    useEffect(() => {
        if (accType === ACCOUNT_TYPE.JOINT_ACCOUNT && refNumber === "") {

            if (updatedStepsActive.length < 8) {
                setUpdatedStepsActive(stepsActive => [...stepsActive, {
                    icon: <img className={getIconClassName(8)} src={step_8_active_img}/>
                }])
            }
            if (updatedStepsInactive.length < 8) {
                setUpdatedStepsInactive(stepsInactive => [...stepsInactive, {
                    icon: <img className={getIconClassName(8)} src={step_8_inactive_img}/>
                }])
            }

        } else {
            if (updatedStepsActive.length >= 8) {
                setUpdatedStepsActive(stepsActive.slice(0, 7))
            }
            if (updatedStepsInactive.length >= 8) {
                setUpdatedStepsInactive(stepsInactive.slice(0, 7))
            }
        }
    }, [accType, refNumber]);

    const next = (curStep: number) => {
        setCurrent(curStep + 1);
    };

    const switchCurrentActiveStep = (step: number) => {
        setCurrent(step);
    };

    const prev = () => {
        setCurrent(current - 1);
        console.log(current)
    };
    const renderIcon = (index: number) => {
        if (index < current - 1) {
            return updatedStepsActive[index]?.icon;
        }
        if (current - 1 === index) {
            return updatedStepsActive[index]?.icon;
        }
        return updatedStepsInactive[index]?.icon;
    };

    /**
     * this function performs when next button clicked in Stepper components. if save or update this function
     * will perform
     **/
    const getFilledDateFromSteps = (data: CustomerWrapperDto) => {
        console.log('savedData',savedUserDetail)
        console.log('data',data)
        setSpinnerLoad(true)
        // TODO -  verify
        data.nextStep = current + 1
        customerService.saveCustomerData(data).then(res => {
            if (res.data !== null) {
                setSpinnerLoad(false);
                setSavedUserDetail(res.data.results)

                switchCurrentActiveStep(res.data.results.currentActiveStep)
                console.log('res.data.results',res.data.results)

            } else {
                setSpinnerLoad(false);
                console.log('else')

                updateStateWithOldData();
                message.error(MSG_UNABLE_TO_SAVE_CUSTOMER_DETAILS_ERROR).then();
            }
        }).catch(reason => {

            updateStateWithOldData();
            ErrorHandler.handleError(reason);
            setTimeout(()=>{
                setSpinnerLoad(false);
            },2000)
        })
    }

    const items = updatedStepsInactive.map((item, index) => ({key: index, icon: renderIcon(index)}));

    useEffect(() => {
        getLoggedUser();
    }, [accType])

    const getLoggedUser = () => {
        getUserInfo().then((res: any) => {
            console.log(res)
            getCustByUserName(res.preferred_username)
        });
    }

    const updateStateWithOldData = () => {
        console.log("updateStateWithOldData")
        getUserInfo().then((res: any) => {
            customerService.getCustomerByUserName(res.preferred_username).then((res: any) => {
                if (res.data.results != null) {

                    setSavedUserDetail(res.data.results)
                    console.log("updateStateWithOldData", res.data.results)

                }

            }).catch((reason) => {
                ErrorHandler.handleError(reason);
            });
        });
    }
    /**
     * this function used to get customer detail if have . this function gets CustomerWrapperDto. if new customer
     * this function gets only identificationSourse and identificationValue. else this functions resieves the -
     * - customer data object also.
     **/
    const getCustByUserName = (userName: string) => {
        customerService.getCustomerByUserName(userName).then((res: any) => {
            console.log('ssasa',res.data.results)
            if (res.data.results != null) {
                setSavedUserDetail(res.data.results)
                if (res.data.results.customerMstDto === null) {
                    if (undefined === props.history.location.state) {
                        history.push('/account-type-selection')
                    }
                }
                // redirect customer to dashboard if customer already completed time slot screen
                if(res.data.results.isTimeSlotSelected){
                    history.push('/workflow/customer/dashboard')
                }
                handleAccTypeAndRefNumber(res.data.results)
                // jump to next step if customer data already filled in a step
                if (res.data.results.currentActiveStep != null) {
                    switchCurrentActiveStep(res.data.results.currentActiveStep)
                }
            }

        }).catch((reason) => {
            ErrorHandler.handleError(reason);
        });
    }

    const handleAccTypeAndRefNumber = (userDetail: CustomerWrapperDto) => {
        if (props.location?.state == undefined) {
            if (userDetail.customerMstDto) {
                setAccType(userDetail?.customerMstDto.initialAccountTypeId)
                setRefNumber(savedUserDetail?.customerMstDto.jointReferenceNumber ?? "")
            }

        } else {
            setAccType(props.location.state.accountType)
            setRefNumber(undefined != props.location.state.referenceNumber ?
                props.location.state.referenceNumber : "")
        }
    }

    const logout = (e: any) => {
        if (keycloak.authenticated) {
            // keycloak.logout({redirectUri: `${redirectUri}`})
            keycloak.logout({redirectUri: window.location.origin});
        }
    }

    return (

        <div>
            <Spin spinning={isSpinnerLoading} tip="Loading" size="large">
                <Affix offsetTop={1} className={'top-affix'}>
                    <Row className='logo-area-row'>
                        <Col lg={24} sm={24} md={24} xs={24} className='logo-area-col'>
                            <div style={{display: "flex"}}>
                                <div className={'imageDivLogo'}>
                                    <img src={xappHomeLogo} alt="logo" className='ndblogo-original'/>
                                </div>
                                <div style={{marginLeft: 8}}>
                                    <h1 className='create-account-text'>Create Account</h1>
                                    <h5 className='easy-step-text'>Create your NDBW account in
                                        {accType === ACCOUNT_TYPE.JOINT_ACCOUNT && !refNumber ? ' 8' : ' 7'} easy
                                        steps
                                    </h5>
                                </div>
                            </div>
                            <div>
                                <Tooltip title='Sign Out'>
                                    <Button onClick={logout}><PoweroffOutlined/></Button>
                                </Tooltip>

                            </div>

                        </Col>
                    </Row>
                </Affix>
                <div className="steps_form_content">
                    <Row gutter={[16, 0]} className='stepper-component-row'>
                        <Col xxl={{span: 14, offset: 5}} xl={{span: 18, offset: 3}} lg={{span: 18, offset: 3}}
                             md={{span: 20, offset: 2}} sm={{span: 0}} xs={{span: 0}} className='create-account-stepper'>
                            <Affix offsetTop={94}>
                                <Steps current={current - 1} items={items} direction={'horizontal'}>
                                </Steps>
                            </Affix>
                        </Col>
                        <Col xxl={{span: 14, offset: 5}} xl={{span: 18, offset: 3}} lg={{span: 18, offset: 3}}
                             md={{span: 20, offset: 2}} sm={{span: 24}} className='stepper-component-col'>
                            <Card className='create-account-form-main-card'>

                                {
                                    savedUserDetail && accType ?
                                        <div className="steps-content">

                                            {
                                                current === 1 ?
                                                    <UserDetails getStepperFilledData={getFilledDateFromSteps}
                                                                 currentCustomerDetail={savedUserDetail}
                                                                 switchStep={() => next(1)}
                                                                 accountTypeId={accType}
                                                                 refNumber={refNumber}
                                                                 isFromSummaryView={false}

                                                    /> :
                                                    current === 2 ?
                                                        <ContactDetails
                                                            savedCusDetailFromPreviousStep={savedUserDetail}
                                                            getStepperFilledData={getFilledDateFromSteps}
                                                            switchStep={() => next(2)}
                                                            isFromSummaryView={false}
                                                        /> :
                                                        current === 3 ?
                                                            <OccupationDetails
                                                                savedCusDetailFromPreviousStep={savedUserDetail}
                                                                getStepperFilledData={getFilledDateFromSteps}
                                                                switchStep={() => next(3)}
                                                                isFromSummaryView={false}
                                                            /> :
                                                            current === 4 ?
                                                                <BankAccountDetails
                                                                    savedCusDetailFromPreviousStep={savedUserDetail}
                                                                    getStepperFilledData={getFilledDateFromSteps}
                                                                    switchStep={() => next(4)}
                                                                    isFromSummaryView={false}
                                                                /> :
                                                                current === 5 ?
                                                                    <OtherDetail
                                                                        savedCusDetailFromPreviousStep={savedUserDetail}
                                                                        getStepperFilledData={getFilledDateFromSteps}
                                                                        switchStep={() => next(5)}
                                                                        isFromSummaryView={false}
                                                                    /> :
                                                                    current === 6 ?
                                                                        <AttachmentAndSupportingDetail
                                                                            savedCusDetailFromPreviousStep={savedUserDetail}
                                                                            getStepperFilledData={getFilledDateFromSteps}
                                                                            switchStep={() => next(6)}
                                                                            isFromSummaryView={false}
                                                                        /> :
                                                                        current === 7 ?
                                                                            <Acknowledgement
                                                                                isFromSummaryView={false}
                                                                                switchStep={() => next(7)}
                                                                                savedCusDetailFromPreviousStep={savedUserDetail}
                                                                                getStepperFilledData={getFilledDateFromSteps}
                                                                            /> :
                                                                            /**
                                                                             * refNumber === "" means the user is second applicant*/
                                                                            current === 8 && accType === ACCOUNT_TYPE.JOINT_ACCOUNT && refNumber === "" ?
                                                                                <SecondApplicantDetail
                                                                                    isFromSummaryView={false}
                                                                                    switchStep={() => next(8)}
                                                                                    savedCusDetailFromPreviousStep={savedUserDetail}
                                                                                    getStepperFilledData={getFilledDateFromSteps}
                                                                                /> :
                                                                                <SummaryDetail
                                                                                    savedCusDetailFromPreviousStep={savedUserDetail}/>

                                            }
                                        </div>
                                        : <></>
                                }


                                <div className="steps-action main-stepper-buttons">
                                    {current > 1 && (
                                        <Button onClick={prev} type="primary" className='form_previous_btn'>
                                            Previous
                                        </Button>
                                    )}
                                </div>
                            </Card>

                        </Col>
                    </Row>
                </div>

            </Spin>
        </div>

    )

}
export default StepperContainerIndividualAccount;

